import React, { Component } from 'react'

import PageHeader from 'ui/PageHeader'
import PropTypes from 'prop-types'

class Page extends Component {
    render() {
        const { className, title, children } = this.props
        return (
            <div className={`page ${className}`}>
                <PageHeader h1={title} />
                {children}
            </div>
        )
    }
}

Page.propTypes = {
    title: PropTypes.string.isRequired,
    className: PropTypes.string,
    children: PropTypes.node,
}

export default Page
